"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBaseDevelopmentOverrideKeySchema = exports.APP_BASE_DEVELOPMENT_OVERRIDES_DESCRIPTION = exports.APP_BASE_DEVELOPMENT_OVERRIDE_KEYS = exports.AppBaseDevelopmentTypedOverrideSchema = exports.AppBaseDevelopmentTypedChoicesSchema = exports.AppBaseDevelopmentBindingsSchema = exports.AppBaseDevelopmentIntentSchema = exports.AppBaseDevelopmentSmokeResultSchema = exports.AppBaseDevelopmentSmokeCheckSchema = exports.AppBaseDevelopmentApplyResultSchema = exports.AppBaseDevelopmentStatusSchema = exports.AppBaseDevelopmentValidationResultSchema = exports.AppBaseDevelopmentComparableTreeSchema = exports.AppBaseDevelopmentComparableNodeSchema = exports.AppBaseDevelopmentTreeSchema = exports.AppBaseDevelopmentNodeSchema = exports.AppBaseDevelopmentProgressSchema = exports.AppBaseDevelopmentRecipeSchema = exports.AppBaseDevelopmentConfirmationLedgerSchema = exports.AppBaseDevelopmentRecipeMutationSchema = exports.AppBaseDevelopmentDiffSchema = exports.AppBaseDevelopmentDiffEntrySchema = exports.AppBaseDevelopmentNextStepSchema = exports.AppBaseDevelopmentGapExplanationSchema = exports.AppBaseDevelopmentGapSchema = exports.AppBaseDiagnosticReportSchema = exports.AppBaseDiagnosticSchema = exports.AppBaseDiagnosticActionSchema = exports.AppBaseDiagnosticScopeSchema = exports.AppBaseDiagnosticSeveritySchema = exports.AppBaseDiagnosticStageSchema = exports.AppBaseDevelopmentValidationErrorSchema = exports.AppBaseDevelopmentTargetSchema = exports.AppBaseDevelopmentValueSchema = exports.AppBaseDevelopmentJsonValueSchema = exports.AppBaseDevelopmentScalarValueSchema = exports.AppBaseDevelopmentSmokeCheckStatusSchema = exports.AppBaseDevelopmentDiffImpactSchema = exports.AppBaseDevelopmentNextStepActionKindSchema = exports.AppBaseDevelopmentGapSeveritySchema = exports.AppBaseDevelopmentNodeKindSchema = exports.AppBaseDevelopmentValueKindSchema = exports.AppBaseDevelopmentValueSourceSchema = exports.AppBaseDevelopmentNodeStatusSchema = exports.APP_BASE_DEVELOPMENT_DATABASE_MODES = exports.AppBasePageDataInputSchema = exports.APP_BASE_DEVELOPMENT_PAGE_DATA_MODES = exports.APP_BASE_DEVELOPMENT_MODES = exports.AppBaseDevelopmentModeSchema = exports.APP_BASE_DEVELOPMENT_TREE_SCHEMA_VERSION = void 0;
exports.APP_BASE_DEVELOPMENT_NODE_CONFIG_MATRIX = exports.AppBaseDevelopmentPlanInputSchema = exports.AppBaseDevelopmentTypedOverridesSchema = void 0;
exports.appBaseDevelopmentInputExample = appBaseDevelopmentInputExample;
exports.appBaseDevelopmentOverrideExample = appBaseDevelopmentOverrideExample;
exports.createAppBaseDevelopmentNextStep = createAppBaseDevelopmentNextStep;
exports.createAppBaseDevelopmentGap = createAppBaseDevelopmentGap;
exports.createAppBaseDevelopmentNode = createAppBaseDevelopmentNode;
exports.deriveAppBaseDevelopmentNodeStatus = deriveAppBaseDevelopmentNodeStatus;
exports.calculateAppBaseDevelopmentProgress = calculateAppBaseDevelopmentProgress;
exports.collectAppBaseDevelopmentGaps = collectAppBaseDevelopmentGaps;
exports.collectAppBaseDevelopmentNextSteps = collectAppBaseDevelopmentNextSteps;
exports.finalizeAppBaseDevelopmentTree = finalizeAppBaseDevelopmentTree;
const zod_1 = require("zod");
const app_access_vocabulary_1 = require("./app-access-vocabulary");
const app_base_capability_assessment_1 = require("./app-base-capability-assessment");
const app_base_config_1 = require("./app-base-config");
const app_base_contract_1 = require("./app-base-contract");
const app_base_database_requirements_1 = require("./app-base-database-requirements");
const app_page_access_1 = require("./app-page-access");
const public_host_names_1 = require("./public-host-names");
exports.APP_BASE_DEVELOPMENT_TREE_SCHEMA_VERSION = 1;
exports.AppBaseDevelopmentModeSchema = zod_1.z.enum([
    'create_app_base_from_scratch',
    'create_app',
    'instantiate_marketplace_app',
    'add_app',
    'edit_app',
    'edit_mount',
    'move_app',
    'replace_app',
    'unmount_app',
    'delete_app',
    'bind_database',
    'rebind_database',
    'unbind_database',
    'create_table_for_page',
    'connect_data',
    'share_data_with_page',
    'disconnect_data',
    'fix_defect',
    'bind_automation',
    'bind_export',
    'configure_attachments',
    'change_visibility',
    'inspect_status',
    'smoke_test_app_base',
    'publish_app_base',
]);
exports.APP_BASE_DEVELOPMENT_MODES = exports.AppBaseDevelopmentModeSchema.options;
exports.APP_BASE_DEVELOPMENT_PAGE_DATA_MODES = [
    'create_table_for_page',
    'connect_data',
    'share_data_with_page',
    'disconnect_data',
    'fix_defect',
];
/** User-facing data intent; storage placement and resource types are derived. */
exports.AppBasePageDataInputSchema = zod_1.z
    .object({
    page: zod_1.z.string().startsWith('/').optional(),
    table: zod_1.z.string().min(1).optional(),
    databaseId: zod_1.z.string().min(1).optional(),
    columnIds: zod_1.z.array(zod_1.z.string().min(1)).optional(),
    defectId: zod_1.z.string().min(1).optional(),
    repair: zod_1.z
        .enum([
        'create-table',
        'connect-data',
        'replace-source',
        'disconnect-source',
        'select-columns',
        'request-access',
    ])
        .optional(),
})
    .strict();
/** Modes whose plan targets exactly one database binding of the App. */
exports.APP_BASE_DEVELOPMENT_DATABASE_MODES = [
    'bind_database',
    'rebind_database',
    'unbind_database',
    'configure_attachments',
];
exports.AppBaseDevelopmentNodeStatusSchema = zod_1.z.enum([
    'missing',
    'defaulted',
    'configured',
    'invalid',
    'ready',
]);
exports.AppBaseDevelopmentValueSourceSchema = zod_1.z.enum([
    'system',
    'developer',
    'derived',
    'binding',
]);
exports.AppBaseDevelopmentValueKindSchema = zod_1.z.enum([
    'freeIntent',
    'freeContent',
    'typedChoice',
    'typedOverride',
    'workspaceBinding',
    'systemDefault',
    'derived',
]);
exports.AppBaseDevelopmentNodeKindSchema = zod_1.z.enum([
    'appBase',
    'shell',
    'exposure',
    'composition',
    'mount',
    'app',
    'route',
    'file',
    'resource',
    'databaseRequirement',
    'columnRequirement',
    'binding',
    'command',
    'agentAction',
    'automationBinding',
    'export',
    'seo',
    'operatorControl',
    'health',
    'publish',
]);
exports.AppBaseDevelopmentGapSeveritySchema = zod_1.z.enum([
    'info',
    'warning',
    'blocking',
]);
exports.AppBaseDevelopmentNextStepActionKindSchema = zod_1.z.enum([
    'set_intent',
    'choose_typed_value',
    'bind_workspace_entity',
    'accept_default',
    'provide_override_reason',
    'repair',
    'run_smoke_test',
    'publish',
]);
exports.AppBaseDevelopmentDiffImpactSchema = zod_1.z.enum([
    'none',
    'runtime',
    'data',
    'permission',
    'publish',
    'seo',
]);
exports.AppBaseDevelopmentSmokeCheckStatusSchema = zod_1.z.enum([
    'pass',
    'fail',
    'skip',
]);
exports.AppBaseDevelopmentScalarValueSchema = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
]);
exports.AppBaseDevelopmentJsonValueSchema = zod_1.z.lazy(() => zod_1.z.union([
    exports.AppBaseDevelopmentScalarValueSchema,
    zod_1.z.array(exports.AppBaseDevelopmentJsonValueSchema),
    zod_1.z.record(zod_1.z.string(), exports.AppBaseDevelopmentJsonValueSchema),
]));
exports.AppBaseDevelopmentValueSchema = exports.AppBaseDevelopmentJsonValueSchema;
exports.AppBaseDevelopmentTargetSchema = zod_1.z
    .object({
    appBaseId: zod_1.z.string().min(1).optional(),
    appId: zod_1.z.string().min(1).optional(),
    rootDocId: zod_1.z.string().min(1).optional(),
    /**
     * Slug of the target App, as used in its preview and runtime URLs. The
     * server rebinds it from canonical state whenever appBaseId resolves.
     */
    appBaseSlug: zod_1.z.string().min(1).optional(),
    /**
     * Digest of the persisted App config the plan was built on. The server
     * stamps it while planning; apply rejects the plan once the App changed
     * since (another editor, AI or MCP), so no change is overwritten unseen.
     */
    baseConfigDigest: zod_1.z.string().length(64).optional(),
    /**
     * Digest of each top-level part of that config (routes, appDefinitions,
     * databaseBindings, ...), so a stale apply names what changed.
     */
    baseConfigPartDigests: zod_1.z
        .record(zod_1.z.string(), zod_1.z.string().length(16))
        .optional(),
    /**
     * The audiences the page rights of the target App Container reach. The
     * server stamps it while planning; a new page is for the openest of them
     * unless the plan names its audience.
     */
    appBaseAudiences: zod_1.z.array(app_access_vocabulary_1.AppAccessAudienceSchema).optional(),
    marketplaceTemplateId: zod_1.z.string().min(1).optional(),
    marketplaceTargetKind: zod_1.z
        .enum(['existing_app_base', 'new_app_base'])
        .optional(),
    marketplaceTargetSlug: zod_1.z
        .string()
        .min(public_host_names_1.APP_BASE_SLUG_MIN_LENGTH)
        .max(public_host_names_1.APP_BASE_SLUG_MAX_LENGTH)
        .optional(),
    marketplaceOperationId: zod_1.z.string().min(8).optional(),
    marketplaceConfirmedPreflightDigest: zod_1.z.string().length(64).optional(),
    marketplaceTargetRootRoutePath: zod_1.z.string().min(1).optional(),
    marketplaceTargetVersionNumber: zod_1.z.number().int().positive().optional(),
    marketplaceDatabaseMappings: app_base_database_requirements_1.AppDatabaseRequirementDecisionMapSchema.optional(),
})
    .strict();
exports.AppBaseDevelopmentValidationErrorSchema = zod_1.z
    .object({
    code: zod_1.z.string().min(1),
    message: zod_1.z.string().min(1),
    path: zod_1.z.array(zod_1.z.string().min(1)),
})
    .strict();
exports.AppBaseDiagnosticStageSchema = zod_1.z.enum([
    'authoring',
    'static_validation',
    'installation',
    'preview_boot',
    'route_loading',
    'data_loading',
    'interaction',
    'publish',
]);
exports.AppBaseDiagnosticSeveritySchema = zod_1.z.enum([
    'info',
    'warning',
    'error',
]);
exports.AppBaseDiagnosticScopeSchema = zod_1.z
    .object({
    appId: zod_1.z.string().min(1).optional(),
    routePath: zod_1.z.string().min(1).optional(),
    pageId: zod_1.z.string().min(1).optional(),
    sourceKey: zod_1.z.string().min(1).optional(),
    actionId: zod_1.z.string().min(1).optional(),
    controlId: zod_1.z.string().min(1).optional(),
    filePath: zod_1.z.string().min(1).optional(),
    nodeId: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.AppBaseDiagnosticActionSchema = zod_1.z
    .object({
    action: zod_1.z.enum(['repair_with_ai', 'retry', 'inspect', 'validate', 'smoke']),
    label: zod_1.z.string().min(1),
    allowedTool: zod_1.z.string().min(1).optional(),
})
    .strict();
/**
 * One safe, channel-neutral diagnostic. UI, Copilot and external MCP agents
 * consume this exact contract; context pills are presentation only.
 */
exports.AppBaseDiagnosticSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    diagnosticId: zod_1.z.string().min(8),
    code: zod_1.z.string().min(1),
    severity: exports.AppBaseDiagnosticSeveritySchema,
    stage: exports.AppBaseDiagnosticStageSchema,
    blocking: zod_1.z.boolean(),
    retryable: zod_1.z.boolean(),
    message: zod_1.z.string().min(1),
    technicalDetail: zod_1.z.string().min(1).max(1000).optional(),
    target: exports.AppBaseDevelopmentTargetSchema,
    scope: exports.AppBaseDiagnosticScopeSchema.prefault({}),
    durationMs: zod_1.z.number().int().nonnegative().optional(),
    suggestedActions: zod_1.z.array(exports.AppBaseDiagnosticActionSchema),
})
    .strict();
exports.AppBaseDiagnosticReportSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    status: zod_1.z.enum(['pass', 'warning', 'fail']),
    target: exports.AppBaseDevelopmentTargetSchema,
    diagnostics: zod_1.z.array(exports.AppBaseDiagnosticSchema),
    generatedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.AppBaseDevelopmentGapSchema = zod_1.z
    .object({
    gapId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    severity: exports.AppBaseDevelopmentGapSeveritySchema,
    blocking: zod_1.z.boolean(),
    reason: zod_1.z.string().min(1),
    requiredValueKind: exports.AppBaseDevelopmentValueKindSchema.optional(),
    expectedSchemaRef: zod_1.z.string().min(1).optional(),
    allowedActions: zod_1.z.array(zod_1.z.string().min(1)),
    /** The smallest plan argument that answers the gap. */
    inputExample: exports.AppBaseDevelopmentValueSchema.optional(),
})
    .strict();
exports.AppBaseDevelopmentGapExplanationSchema = zod_1.z
    .object({
    gapId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    reason: zod_1.z.string().min(1),
    resolution: zod_1.z.string().min(1),
    allowedActions: zod_1.z.array(zod_1.z.string().min(1)),
})
    .strict();
exports.AppBaseDevelopmentNextStepSchema = zod_1.z
    .object({
    nextStepId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    actionKind: exports.AppBaseDevelopmentNextStepActionKindSchema,
    label: zod_1.z.string().min(1),
    allowedTool: zod_1.z.string().min(1).optional(),
    requiredConfirmation: zod_1.z.string().min(1).optional(),
    /** The smallest plan argument that takes this step. */
    inputExample: exports.AppBaseDevelopmentValueSchema.optional(),
})
    .strict();
exports.AppBaseDevelopmentDiffEntrySchema = zod_1.z
    .object({
    nodeId: zod_1.z.string().min(1),
    field: zod_1.z.string().min(1),
    oldValue: exports.AppBaseDevelopmentValueSchema.optional(),
    newValue: exports.AppBaseDevelopmentValueSchema.optional(),
    impact: exports.AppBaseDevelopmentDiffImpactSchema,
})
    .strict();
exports.AppBaseDevelopmentDiffSchema = zod_1.z
    .object({
    entries: zod_1.z.array(exports.AppBaseDevelopmentDiffEntrySchema),
})
    .strict();
exports.AppBaseDevelopmentRecipeMutationSchema = zod_1.z
    .object({
    mutationId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    type: zod_1.z.string().min(1),
    input: exports.AppBaseDevelopmentJsonValueSchema.optional(),
    confirmationKey: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.AppBaseDevelopmentConfirmationLedgerSchema = zod_1.z
    .object({
    required: zod_1.z.array(zod_1.z.string().min(1)),
    accepted: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
exports.AppBaseDevelopmentRecipeSchema = zod_1.z
    .object({
    recipeId: zod_1.z.string().min(1),
    mode: exports.AppBaseDevelopmentModeSchema,
    mutations: zod_1.z.array(exports.AppBaseDevelopmentRecipeMutationSchema),
    confirmationLedger: exports.AppBaseDevelopmentConfirmationLedgerSchema,
})
    .strict();
exports.AppBaseDevelopmentProgressSchema = zod_1.z
    .object({
    ready: zod_1.z.number().int().nonnegative(),
    configured: zod_1.z.number().int().nonnegative(),
    defaulted: zod_1.z.number().int().nonnegative(),
    missing: zod_1.z.number().int().nonnegative(),
    invalid: zod_1.z.number().int().nonnegative(),
    total: zod_1.z.number().int().nonnegative(),
    blocking: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.AppBaseDevelopmentNodeSchema = zod_1.z.lazy(() => zod_1.z
    .object({
    nodeId: zod_1.z.string().min(1),
    kind: exports.AppBaseDevelopmentNodeKindSchema,
    label: zod_1.z.string().min(1),
    required: zod_1.z.boolean(),
    source: exports.AppBaseDevelopmentValueSourceSchema,
    valueKind: exports.AppBaseDevelopmentValueKindSchema,
    status: exports.AppBaseDevelopmentNodeStatusSchema,
    value: exports.AppBaseDevelopmentValueSchema.optional(),
    defaultValue: exports.AppBaseDevelopmentValueSchema.optional(),
    allowedValues: zod_1.z.array(exports.AppBaseDevelopmentValueSchema).optional(),
    schemaRef: zod_1.z.string().min(1).optional(),
    overrideReason: zod_1.z.string().min(1).optional(),
    validationErrors: zod_1.z.array(exports.AppBaseDevelopmentValidationErrorSchema),
    children: zod_1.z.array(exports.AppBaseDevelopmentNodeSchema),
    nextSteps: zod_1.z.array(exports.AppBaseDevelopmentNextStepSchema),
})
    .strict()
    .superRefine((node, ctx) => {
    if (node.valueKind === 'typedChoice') {
        const hasChoices = (node.allowedValues?.length ?? 0) > 0 || !!node.schemaRef;
        if (!hasChoices) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'typedChoice nodes require allowedValues or schemaRef',
                path: ['allowedValues'],
            });
        }
    }
    if (node.valueKind === 'typedOverride' &&
        (!node.schemaRef || !node.overrideReason)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'typedOverride nodes require both schemaRef and overrideReason',
            path: ['overrideReason'],
        });
    }
    if (node.valueKind === 'typedOverride' && node.source !== 'developer') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'typedOverride values must be developer sourced',
            path: ['source'],
        });
    }
    if ((node.valueKind === 'freeIntent' ||
        node.valueKind === 'freeContent') &&
        node.source !== 'developer') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'free values must be developer sourced',
            path: ['source'],
        });
    }
    if (node.valueKind === 'systemDefault' && node.source !== 'system') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'systemDefault values must be system sourced',
            path: ['source'],
        });
    }
    if (node.valueKind === 'derived' && node.source !== 'derived') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'derived values must be derived sourced',
            path: ['source'],
        });
    }
    if (node.valueKind === 'workspaceBinding' &&
        node.source !== 'binding') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'workspace bindings must be binding sourced',
            path: ['source'],
        });
    }
}));
exports.AppBaseDevelopmentTreeSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_DEVELOPMENT_TREE_SCHEMA_VERSION),
    target: exports.AppBaseDevelopmentTargetSchema,
    mode: exports.AppBaseDevelopmentModeSchema,
    root: exports.AppBaseDevelopmentNodeSchema,
    progress: exports.AppBaseDevelopmentProgressSchema,
    gaps: zod_1.z.array(exports.AppBaseDevelopmentGapSchema),
    nextSteps: zod_1.z.array(exports.AppBaseDevelopmentNextStepSchema),
    diff: exports.AppBaseDevelopmentDiffSchema.optional(),
    recipe: exports.AppBaseDevelopmentRecipeSchema.optional(),
    appTypes: zod_1.z.array(app_base_capability_assessment_1.AppBaseCapabilityAssessmentSchema).default([]),
})
    .strict();
exports.AppBaseDevelopmentComparableNodeSchema = zod_1.z.lazy(() => zod_1.z
    .object({
    nodeId: zod_1.z.string().min(1),
    kind: exports.AppBaseDevelopmentNodeKindSchema,
    status: exports.AppBaseDevelopmentNodeStatusSchema,
    value: exports.AppBaseDevelopmentValueSchema.optional(),
    defaultValue: exports.AppBaseDevelopmentValueSchema.optional(),
    children: zod_1.z.array(exports.AppBaseDevelopmentComparableNodeSchema),
})
    .passthrough());
exports.AppBaseDevelopmentComparableTreeSchema = zod_1.z
    .object({
    mode: exports.AppBaseDevelopmentModeSchema,
    root: exports.AppBaseDevelopmentComparableNodeSchema,
})
    .passthrough();
exports.AppBaseDevelopmentValidationResultSchema = zod_1.z
    .object({
    valid: zod_1.z.boolean(),
    errors: zod_1.z.array(exports.AppBaseDevelopmentValidationErrorSchema),
    tree: exports.AppBaseDevelopmentTreeSchema,
})
    .strict();
exports.AppBaseDevelopmentStatusSchema = zod_1.z
    .object({
    target: exports.AppBaseDevelopmentTargetSchema,
    mode: exports.AppBaseDevelopmentModeSchema,
    progress: exports.AppBaseDevelopmentProgressSchema,
    gaps: zod_1.z.array(exports.AppBaseDevelopmentGapSchema),
    nextSteps: zod_1.z.array(exports.AppBaseDevelopmentNextStepSchema),
})
    .strict();
exports.AppBaseDevelopmentApplyResultSchema = zod_1.z
    .object({
    applied: zod_1.z.array(zod_1.z.string().min(1)),
    skipped: zod_1.z.array(zod_1.z
        .object({
        mutationId: zod_1.z.string().min(1),
        reason: zod_1.z.string().min(1),
    })
        .strict()),
    failed: zod_1.z.array(zod_1.z
        .object({
        mutationId: zod_1.z.string().min(1),
        reason: zod_1.z.string().min(1),
        nodeId: zod_1.z.string().min(1).optional(),
        diagnostics: zod_1.z.array(exports.AppBaseDiagnosticSchema).optional(),
    })
        .strict()),
    authoringOutcome: zod_1.z
        .object({
        kind: zod_1.z.literal('app_draft'),
        appBaseId: zod_1.z.string().min(1),
        appId: zod_1.z.string().min(1),
        mountId: zod_1.z.string().min(1),
        draftVersion: zod_1.z.number().int().positive(),
        nextStep: zod_1.z.literal('preview_in_target_app'),
    })
        .strict()
        .optional(),
    summary: zod_1.z
        .object({
        appBaseId: zod_1.z.string().min(1),
        routeCount: zod_1.z.number().int().nonnegative(),
        routes: zod_1.z.array(zod_1.z
            .object({
            path: zod_1.z.string().min(1),
            /** The audiences the rights of the page make active. */
            access: zod_1.z.array(app_access_vocabulary_1.AppAccessAudienceSchema),
        })
            .strict()),
        capabilities: zod_1.z.array(zod_1.z.string().min(1)),
        dataSourceCount: zod_1.z.number().int().nonnegative(),
        dataSources: zod_1.z.array(zod_1.z
            .object({
            key: zod_1.z.string().min(1),
            role: zod_1.z.string().min(1),
        })
            .strict()),
        quota: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable(),
        quotaRemaining: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable(),
        planRestrictions: zod_1.z.array(zod_1.z.string().min(1)),
        incompatibilities: zod_1.z.array(zod_1.z.string().min(1)),
    })
        .strict()
        .optional(),
    tree: exports.AppBaseDevelopmentTreeSchema,
})
    .strict();
exports.AppBaseDevelopmentSmokeCheckSchema = zod_1.z
    .object({
    checkId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    status: exports.AppBaseDevelopmentSmokeCheckStatusSchema,
    failReason: zod_1.z.string().min(1).optional(),
    nextStepId: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.AppBaseDevelopmentSmokeResultSchema = zod_1.z
    .object({
    target: exports.AppBaseDevelopmentTargetSchema,
    status: exports.AppBaseDevelopmentSmokeCheckStatusSchema,
    checks: zod_1.z.array(exports.AppBaseDevelopmentSmokeCheckSchema),
    blockingFailures: zod_1.z.array(zod_1.z.string().min(1)),
    gaps: zod_1.z.array(exports.AppBaseDevelopmentGapSchema),
    nextSteps: zod_1.z.array(exports.AppBaseDevelopmentNextStepSchema),
    recipeId: zod_1.z.string().min(1).optional(),
    treeVersion: zod_1.z.number().int().positive().optional(),
    tree: exports.AppBaseDevelopmentTreeSchema.optional(),
})
    .strict();
exports.AppBaseDevelopmentIntentSchema = zod_1.z
    .object({
    title: zod_1.z.string().min(1).optional(),
    brief: zod_1.z.string().min(1).optional(),
    goals: zod_1.z.array(zod_1.z.string().min(1)).optional(),
    labels: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
    content: zod_1.z.record(zod_1.z.string(), exports.AppBaseDevelopmentValueSchema).optional(),
})
    .strict();
exports.AppBaseDevelopmentBindingsSchema = zod_1.z
    .object({
    databaseId: zod_1.z.string().min(1).optional(),
    viewId: zod_1.z.string().min(1).optional(),
    columnId: zod_1.z.string().min(1).optional(),
    automationId: zod_1.z.string().min(1).optional(),
    credentialId: zod_1.z.string().min(1).optional(),
    docId: zod_1.z.string().min(1).optional(),
    resourceId: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.AppBaseDevelopmentTypedChoicesSchema = zod_1.z
    .object({
    agentActionMode: zod_1.z
        .enum(['none', 'block_owned'])
        .optional()
        .describe('Choose block_owned when the App Module needs a validated Agent Action shared by its form, Copilot, and MCP. The action contract and immutable version are managed by app_agent_action_* tools.'),
    resourceRole: app_base_config_1.AppBaseDataSourceRoleSchema.optional(),
    contentModel: app_base_config_1.AppBaseContentModelSchema.optional(),
    accessMode: zod_1.z.enum(['read', 'write']).optional(),
    commandType: zod_1.z
        .enum(['navigate', 'mutate_row', 'run_automation', 'export_document'])
        .optional(),
    publishOnApply: zod_1.z.boolean().optional(),
    navPlacement: zod_1.z.enum(['primary', 'secondary', 'hidden']).optional(),
    /** `move_app`: the App mounted at the new place takes the old one. */
    swapMountPoints: zod_1.z
        .boolean()
        .optional()
        .describe('move_app only: the App Module mounted at the new place takes the old place of the moved App Module. Without it a taken place is refused.'),
    exportFormat: zod_1.z.enum(['pdf', 'csv', 'json', 'html']).optional(),
})
    .strict()
    .describe(app_base_contract_1.APP_BASE_APP_TYPE_GUIDE);
exports.AppBaseDevelopmentTypedOverrideSchema = zod_1.z
    .object({
    value: exports.AppBaseDevelopmentValueSchema,
    schemaRef: zod_1.z.string().min(1),
    overrideReason: zod_1.z.string().min(1),
})
    .strict();
/**
 * The plan fields a caller may override. Overrides are keyed by field, not by
 * development-tree node id; any other key is rejected instead of being
 * silently dropped.
 */
exports.APP_BASE_DEVELOPMENT_OVERRIDE_KEYS = [
    'appId',
    'audience',
    'blockId',
    'columnIds',
    'columnLabels',
    'columnOptions',
    'columnTypes',
    'commandId',
    'commandLabel',
    'filePath',
    'label',
    'mountId',
    'routePath',
    'rowLimit',
    'slug',
    'sourceKey',
    'visibleColumnIds',
];
/** Tool-facing description of `overrides`, shared by every plan tool schema. */
exports.APP_BASE_DEVELOPMENT_OVERRIDES_DESCRIPTION = `Typed overrides for system-generated values, keyed by field name (never by tree node id): ${exports.APP_BASE_DEVELOPMENT_OVERRIDE_KEYS.join(', ')}. Any other key is rejected. Every entry must provide value, schemaRef and overrideReason. For bind_database, sourceKey and label name the new data source (defaults derive from the database title); an already bound database keeps its sourceKey, so rename it with unbind_database followed by bind_database. Which rows a page shows comes from its page rights, not from the database connection.`;
exports.AppBaseDevelopmentOverrideKeySchema = zod_1.z.enum(exports.APP_BASE_DEVELOPMENT_OVERRIDE_KEYS);
exports.AppBaseDevelopmentTypedOverridesSchema = zod_1.z
    .partialRecord(exports.AppBaseDevelopmentOverrideKeySchema, exports.AppBaseDevelopmentTypedOverrideSchema)
    .prefault({});
exports.AppBaseDevelopmentPlanInputSchema = zod_1.z
    .object({
    mode: exports.AppBaseDevelopmentModeSchema,
    target: exports.AppBaseDevelopmentTargetSchema.prefault({}),
    intent: exports.AppBaseDevelopmentIntentSchema.prefault({}),
    typedChoices: exports.AppBaseDevelopmentTypedChoicesSchema.prefault({}),
    bindings: exports.AppBaseDevelopmentBindingsSchema.prefault({}),
    access: zod_1.z
        .array(app_page_access_1.AppAccessEditSchema)
        .optional()
        .describe('Rights of existing pages, each edit like the Studio makes it: per page (routePath), optionally one table (sourceKey), and audience. Leave it out to keep the current rights.'),
    overrides: exports.AppBaseDevelopmentTypedOverridesSchema,
    runtimeDiagnostic: exports.AppBaseDiagnosticSchema.optional(),
    data: exports.AppBasePageDataInputSchema.optional(),
})
    .strict();
exports.APP_BASE_DEVELOPMENT_NODE_CONFIG_MATRIX = [
    {
        kind: 'appBase',
        fields: ['manifestId', 'title', 'slug', 'rootDocId'],
        valueKinds: [
            'systemDefault',
            'freeIntent',
            'workspaceBinding',
            'typedOverride',
        ],
        defaultOwner: 'createAppBaseDefaults',
        validator: 'doc/workspace access validator',
        overrideRule: 'slug override only as typedOverride with reason',
    },
    {
        kind: 'shell',
        fields: ['branding', 'navigationPolicy', 'localePolicy'],
        valueKinds: ['typedChoice', 'freeContent', 'typedOverride'],
        defaultOwner: 'createShellDefaults',
        validator: 'shell schema validator',
        overrideRule: 'schemaRef-valid typed overrides only',
    },
    {
        kind: 'exposure',
        fields: ['delivery', 'auth', 'cache', 'robots'],
        valueKinds: ['typedChoice', 'derived'],
        defaultOwner: 'deriveExposureDefaults',
        validator: 'visibility compatibility validator',
        overrideRule: 'delivery is derived and not free-overridable',
    },
    {
        kind: 'composition',
        fields: ['mounts', 'order'],
        valueKinds: ['derived', 'systemDefault', 'typedOverride'],
        defaultOwner: 'deriveCompositionDefaults',
        validator: 'mount uniqueness validator',
        overrideRule: 'order typedOverride allowed with reason',
    },
    {
        kind: 'mount',
        fields: ['mountId', 'appId', 'routePrefix', 'navPlacement'],
        valueKinds: [
            'systemDefault',
            'workspaceBinding',
            'typedChoice',
            'typedOverride',
        ],
        defaultOwner: 'createMountDefaults',
        validator: 'app catalog and route conflict validator',
        overrideRule: 'routePrefix override as typedOverride with reason',
    },
    {
        kind: 'app',
        fields: ['appId', 'title', 'rootRoutePath', 'version'],
        valueKinds: ['systemDefault', 'freeIntent', 'typedChoice', 'typedOverride'],
        defaultOwner: 'createAppDefaults',
        validator: 'AppDefinition schema',
        overrideRule: 'public appId override requires stable reason',
    },
    {
        kind: 'route',
        fields: ['routeId', 'path', 'moduleId', 'navLabel'],
        valueKinds: ['systemDefault', 'freeIntent', 'typedOverride'],
        defaultOwner: 'createRouteDefaults',
        validator: 'route path and module validator',
        overrideRule: 'path override as typedOverride with reason',
    },
    {
        kind: 'file',
        fields: ['fileId', 'path', 'mimeType', 'contentRef'],
        valueKinds: ['freeContent', 'systemDefault', 'derived', 'typedOverride'],
        defaultOwner: 'createArtifactFileDefaults',
        validator: 'artifact file validator',
        overrideRule: 'file path override as typedOverride with reason',
    },
    {
        kind: 'resource',
        fields: ['sourceKey', 'role', 'contentModel', 'accessMode'],
        valueKinds: ['systemDefault', 'typedChoice', 'typedOverride'],
        defaultOwner: 'createResourceDefaults',
        validator: 'resource requirement validator',
        overrideRule: 'sourceKey override as typedOverride with reason',
    },
    {
        kind: 'databaseRequirement',
        fields: ['sourceKey', 'label', 'role', 'contentModel', 'rowWindow'],
        valueKinds: ['systemDefault', 'typedChoice', 'workspaceBinding'],
        defaultOwner: 'createDatabaseRequirementDefaults',
        validator: 'database requirement validator',
        overrideRule: 'requirements stay typed; databaseId is a binding node',
    },
    {
        kind: 'columnRequirement',
        fields: [
            'sourceKey',
            'columnSemanticKey',
            'type',
            'required',
            'options',
            'targetDatabaseId',
            'inverseFieldId',
            'cardinality',
        ],
        valueKinds: ['systemDefault', 'typedChoice', 'workspaceBinding'],
        defaultOwner: 'createColumnRequirementDefaults',
        validator: 'semantic column type and relation contract validator',
        overrideRule: 'columnId comes only from workspace bindings; controlled vocabularies require options and relations require target, inverse field, and cardinality',
    },
    {
        kind: 'binding',
        fields: [
            'databaseId',
            'viewId',
            'columnId',
            'automationId',
            'credentialId',
            'docId',
        ],
        valueKinds: ['workspaceBinding'],
        defaultOwner: 'createBindingSkeleton',
        validator: 'workspace entity access validator',
        overrideRule: 'bindings only from workspace state',
    },
    {
        kind: 'command',
        fields: ['commandId', 'type', 'inputBindings', 'resultPresentation'],
        valueKinds: [
            'systemDefault',
            'typedChoice',
            'workspaceBinding',
            'typedOverride',
        ],
        defaultOwner: 'createCommandDefaults',
        validator: 'command/action capability validator',
        overrideRule: 'commandId override as typedOverride with reason',
    },
    {
        kind: 'agentAction',
        fields: [
            'appBaseId',
            'appId',
            'contract',
            'bindings',
            'dryRun',
            'publishedVersion',
            'agentAction.invoke',
        ],
        valueKinds: ['typedChoice', 'workspaceBinding', 'derived'],
        defaultOwner: 'selectBlockOwnedAgentActionWorkflow',
        validator: 'App Module owner, internal route and published action contract',
        overrideRule: 'Agent Actions are managed only by app_agent_action_* tools',
    },
    {
        kind: 'automationBinding',
        fields: ['automationId', 'trigger', 'inputMapping', 'credentialId'],
        valueKinds: ['workspaceBinding', 'typedChoice'],
        defaultOwner: 'createAutomationBindingSkeleton',
        validator: 'automation and credential access validator',
        overrideRule: 'automation linkage only from workspace state',
    },
    {
        kind: 'export',
        fields: ['exportId', 'format', 'routePath', 'targetActionId'],
        valueKinds: ['systemDefault', 'typedChoice', 'typedOverride'],
        defaultOwner: 'createExportDefaults',
        validator: 'export capability validator',
        overrideRule: 'exportId override as typedOverride with reason',
    },
    {
        kind: 'seo',
        fields: ['title', 'description', 'robots', 'llms', 'structuredData'],
        valueKinds: ['freeContent', 'derived', 'typedChoice'],
        defaultOwner: 'deriveSeoDefaults',
        validator: 'exposure SEO/AIO validator',
        overrideRule: 'robots override gated by exposure',
    },
    {
        kind: 'operatorControl',
        fields: ['controlId', 'controlType', 'targetNodeId'],
        valueKinds: ['systemDefault', 'derived'],
        defaultOwner: 'deriveOperatorControls',
        validator: 'semantic control validator',
        overrideRule: 'no free override',
    },
    {
        kind: 'health',
        fields: [
            'config',
            'composition',
            'mainMount',
            'artifact',
            'dataBinding',
            'interaction',
            'live',
        ],
        valueKinds: ['derived'],
        defaultOwner: 'inspectPersistedAppBaseHealth',
        validator: 'persisted builder/runtime/publish health validator',
        overrideRule: 'health is observed and cannot be overridden',
    },
    {
        kind: 'publish',
        fields: ['publishState', 'readiness', 'smokeChecks'],
        valueKinds: ['derived'],
        defaultOwner: 'derivePublishReadiness',
        validator: 'smoke/publish validator',
        overrideRule: 'no free override',
    },
];
/** The plan argument that sets one input path to its plain value. */
function appBaseDevelopmentInputExample(input) {
    const [head, ...rest] = input.path;
    return {
        [head]: rest.reduceRight((inner, key) => ({ [key]: inner }), input.value),
    };
}
/** The plan input that sets one override, in the envelope overrides take. */
function appBaseDevelopmentOverrideExample(input) {
    return appBaseDevelopmentInputExample({
        path: ['overrides', input.key],
        value: {
            value: input.value,
            schemaRef: input.schemaRef,
            overrideReason: 'Why the user chose this value',
        },
    });
}
function createAppBaseDevelopmentNextStep(input) {
    return exports.AppBaseDevelopmentNextStepSchema.parse({
        nextStepId: `${input.nodeId}:${input.actionKind}`,
        ...input,
    });
}
function createAppBaseDevelopmentGap(input) {
    const severity = input.severity ?? 'blocking';
    return exports.AppBaseDevelopmentGapSchema.parse({
        gapId: `${input.nodeId}:${input.requiredValueKind ?? severity}`,
        nodeId: input.nodeId,
        severity,
        blocking: severity === 'blocking',
        reason: input.reason,
        requiredValueKind: input.requiredValueKind,
        expectedSchemaRef: input.expectedSchemaRef,
        allowedActions: input.allowedActions,
        inputExample: input.inputExample,
    });
}
function createAppBaseDevelopmentNode(input) {
    const status = input.status ??
        deriveAppBaseDevelopmentNodeStatus({
            required: input.required ?? true,
            value: input.value,
            defaultValue: input.defaultValue,
            validationErrors: input.validationErrors ?? [],
        });
    return exports.AppBaseDevelopmentNodeSchema.parse({
        required: true,
        validationErrors: [],
        children: [],
        nextSteps: [],
        ...input,
        status,
    });
}
function deriveAppBaseDevelopmentNodeStatus(input) {
    if (input.validationErrors.length > 0)
        return 'invalid';
    if (input.value !== undefined)
        return 'configured';
    if (input.defaultValue !== undefined)
        return 'defaulted';
    return input.required ? 'missing' : 'ready';
}
function calculateAppBaseDevelopmentProgress(root) {
    const progress = {
        ready: 0,
        configured: 0,
        defaulted: 0,
        missing: 0,
        invalid: 0,
        total: 0,
        blocking: 0,
    };
    const visit = (node) => {
        progress.total++;
        progress[node.status]++;
        if (node.required &&
            (node.status === 'missing' || node.status === 'invalid')) {
            progress.blocking++;
        }
        for (const child of node.children)
            visit(child);
    };
    visit(root);
    return exports.AppBaseDevelopmentProgressSchema.parse(progress);
}
function collectAppBaseDevelopmentGaps(root) {
    const gaps = [];
    const visit = (node) => {
        if (node.status === 'missing' || node.status === 'invalid') {
            gaps.push(createAppBaseDevelopmentGap({
                nodeId: node.nodeId,
                severity: node.required ? 'blocking' : 'warning',
                reason: node.validationErrors[0]?.message ??
                    `${node.label} is ${node.status}`,
                requiredValueKind: node.valueKind,
                expectedSchemaRef: node.schemaRef,
                allowedActions: node.nextSteps.map(step => step.actionKind),
                inputExample: node.nextSteps.find(step => step.inputExample !== undefined)?.inputExample,
            }));
        }
        for (const child of node.children)
            visit(child);
    };
    visit(root);
    return gaps;
}
function collectAppBaseDevelopmentNextSteps(root) {
    const steps = [];
    const seen = new Set();
    const visit = (node) => {
        for (const step of node.nextSteps) {
            if (!seen.has(step.nextStepId)) {
                seen.add(step.nextStepId);
                steps.push(step);
            }
        }
        for (const child of node.children)
            visit(child);
    };
    visit(root);
    return steps;
}
function finalizeAppBaseDevelopmentTree(input) {
    const gaps = collectAppBaseDevelopmentGaps(input.root);
    const nextSteps = collectAppBaseDevelopmentNextSteps(input.root);
    return exports.AppBaseDevelopmentTreeSchema.parse({
        schemaVersion: exports.APP_BASE_DEVELOPMENT_TREE_SCHEMA_VERSION,
        target: input.target,
        mode: input.mode,
        root: input.root,
        progress: calculateAppBaseDevelopmentProgress(input.root),
        gaps,
        nextSteps,
        diff: input.diff,
        recipe: input.recipe,
        appTypes: input.appTypes,
    });
}
